export default "__VITE_PUBLIC_ASSET__d3100e14__"